module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "span-16-lg span-16-md span-14-sm offset-1-sm span-14-xs offset-1-xs"
  }, [_c('h2', [_vm._v("Fonts")]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("Title")]), _vm._v(" "), _c('h1', [_vm._v("Header 1")]), _vm._v(" "), _c('h2', [_vm._v("Header 2")]), _vm._v(" "), _c('p', {
    staticClass: "subheader"
  }, [_vm._v("Subheader")]), _vm._v(" "), _c('p', {
    staticClass: "large"
  }, [_vm._v("Paragraph Large")]), _vm._v(" "), _c('p', {
    staticClass: "large"
  }, [_vm._v(_vm._s(_vm.lorem_ipsum))]), _vm._v(" "), _c('p', [_vm._v("Paragraph")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.lorem_ipsum))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-af3b0328"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/templates/style_guide/fonts.vue
// module id = 658
// module chunks = 1